export default "__VITE_ASSET__BFuGHoK___"